import * as React from 'react'
import {WodSection, WodTestSection} from "app/Views/Tests/WOD/WodSection";

type PreviewProps = {
    data?: any
    preview: boolean
    sectionIndex?: number
}

export class WodForm extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.data ? (this.props.data as WodTestSection[]).map(
            (section, index) => index == this.props.sectionIndex || this.props.sectionIndex == undefined ?
                <WodSection
                    section={section}
                    key={index}
                    index={index}
                    preview={this.props.preview}
                    prev={index == 0 ? null : index - 1}
                    next={index == this.props.data.length - 1 ? null : index + 1}
                /> : null,
            this
        ) : ''}
    </>
}